var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8055 3.5625H18.8608C19.3786 3.5625 19.7983 3.98218 19.7983 4.5C19.7983 5.01782 19.3786 5.4375 18.8608 5.4375H0.9375C0.419678 5.4375 0 5.01782 0 4.5C0 3.98218 0.419678 3.5625 0.9375 3.5625H4.99274L6.50958 0.519287C6.66815 0.20105 6.99316 0 7.34857 0H12.4497C12.8053 0 13.1301 0.20105 13.2887 0.519287L14.8055 3.5625ZM7.92883 1.875L7.08783 3.5625H12.7104L11.8694 1.875H7.92883ZM2.3992 7.125H17.3992C17.9758 7.125 18.4178 7.64209 18.3243 8.21393L15.8708 23.2139C15.7968 23.6671 15.4052 24 14.9458 24H4.85245C4.39322 24 4.00138 23.6671 3.9274 23.2139L1.47397 8.21393C1.3804 7.64246 1.82224 7.125 2.3992 7.125ZM5.64914 22.125H14.1491L16.2958 9H3.50241L5.64914 22.125Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.12464,
    y1: 19,
    x2: 20.2275,
    y2: 8.06045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.85c6453a820671ac11abcd6ccda590c6.svg";
export { ForwardRef as ReactComponent };